import { MenuItem } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";

interface MarkAsPaidButtonProps {
  onOpen: () => void;
  isDisabled?: boolean;
}

export const MarkAsPaidButton = observer(function MarkAsPaidButton(
  props: MarkAsPaidButtonProps,
) {
  return (
    <MenuItem isDisabled={props.isDisabled} onClick={props.onOpen}>
      <Trans>Mark as paid manually</Trans>
    </MenuItem>
  );
});
